import { AxiosResponse } from 'axios';

function base64UrlDecode(str: string): string {
  str = str.replace(/-/g, '+').replace(/_/g, '/');

  while (str.length % 4 !== 0) {
    str += '=';
  }

  return window.atob(str);
}

export const getToken = (response: AxiosResponse) => {
  const idToken = response.data?.idToken;
  if (!idToken) return '';
  return base64UrlDecode(idToken.split('.')[1]);
};

export const getTokenAfterSetProfile = (response: any) =>
  response.idToken ? base64UrlDecode(response.idToken.split('.')[1]) : '';

export const decodeToken = (codedToken: string) =>
  codedToken ? base64UrlDecode(codedToken.split('.')[1]) : '';
